import React from 'react';
import { FaCheckCircle } from 'react-icons/fa'; // Using react-icons for the checkmark

const SubmissionSuccessView = ({ formData, onClose }) => {
  const userName = formData.stepThreeContactInfo?.fullName || 'Valued Customer';
  const serviceName = formData.serviceType || 'your selected service';
  const serviceAddress = formData.stepThreeContactInfo?.streetAddress ? 
    `${formData.stepThreeContactInfo.streetAddress}, ${formData.stepThreeContactInfo.city}` 
    : 'your address';
  const contactMethod = formData.stepThreeContactInfo?.email || formData.stepThreeContactInfo?.phone || 'the provided contact details';

  return (
    <div className="text-center p-6">
      <FaCheckCircle className="text-brand-green-medium text-6xl mx-auto mb-6" />
      <h2 className="text-2xl font-semibold text-brand-text-dark mb-4">Thank You, {userName}!</h2>
      <p className="text-brand-text-light mb-3">
        Your service request has been successfully sent to Quality Air of Texas!
      </p>
      <p className="text-sm text-brand-text-light mb-6">
        We've received your request for <strong>{serviceName}</strong> at <strong>{serviceAddress}</strong>.
        A member of our team will contact you at <strong>{contactMethod}</strong> within 1-2 business hours to confirm your appointment details and answer any questions.
      </p>
      
      {/* Optional: Displaying indicative pricing confirmation */}
      {(formData.stepTwoDetails?.DIAGNOSTIC_FEE || 
        formData.stepTwoDetails?.selectedTier || 
        (formData.stepTwoDetails?.addOns && Object.keys(formData.stepTwoDetails.addOns).some(key => formData.stepTwoDetails.addOns[key]))
       ) && (
        <div className="mb-6 p-3 bg-brand-green-lightest border border-brand-green-light rounded-md text-sm">
          <p className="text-brand-green-dark">
            If you selected any services with indicative pricing (like diagnostic fees, system tiers, or add-ons), these will be discussed and confirmed during our call.
          </p>
        </div>
      )}

      <div className="mb-8">
        <h4 className="font-semibold text-brand-text-dark mb-2">What to Expect Next:</h4>
        <ul className="list-none text-brand-text-light space-y-1 text-sm">
          <li>1. Confirmation Call from our Team.</li>
          <li>2. Appointment Finalized.</li>
          <li>3. Expert Technician Arrives!</li>
        </ul>
      </div>

      <p className="text-xs text-brand-text-light mb-6">
        If you need to make immediate changes or have urgent questions, please call us at 
        <a href="tel:+17139225702" className="font-semibold text-brand-accent-orange hover:underline ml-1">(713) 922-5702</a>.
      </p>

      <button 
        type="button" 
        onClick={onClose} 
        className="cta-button"
      >
        Done
      </button>
    </div>
  );
};

export default SubmissionSuccessView; 